import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Grid, MenuItem, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
import axios from 'axios';
import Cookies from 'js-cookie'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';


export default function CreateCouponDialog({ open, handleClose }) {
    const [clubNumber, setClubNumber] = useState('');
    const [trimestre, setTrimestre] = useState('');
    const [couponCode, setCouponCode] = useState('');
    const [couponMontant, setCouponMontant] = useState('');
    const [raison, setRaison] = useState('');
    const [expirationDate, setExpirationDate] = useState('');
    const [usageLimit, setUsageLimit] = useState('');
    const [discountType, setDiscountType] = useState('fixed_cart');
    

    const MyAxios = axios.create({
        headers: {
            Authorization: "Bearer " + Cookies.get('token'),
        }
    })



    const handleChangeiscountType = (event) => {
        //alert(event.target.value);
        setDiscountType(event.target.value); // Met à jour correctement l'état avec la nouvelle valeur
       // console.log(event.target.value); // Ajouté pour vérifier la nouvelle valeur dans la console
      
    };

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }
    const handleMontantChange = (e) => {
        const value = e.target.value;

        // Utilisation d'une regex pour n'autoriser que les chiffres et les virgules
        const regex = /^[0-9,]*$/;

        // Si la valeur saisie correspond à la regex, on met à jour l'état
        if (regex.test(value)) {
            setCouponMontant(value);
        }
    };
    // Gestion de la soumission du formulaire
    const handleSubmit = () => {
        const newCoupon = {
            clubNumber,
            trimestre,
            couponCode,
            couponMontant,
            discountType,
            raison,
            expirationDate: expirationDate || null, // null si aucune date d'expiration n'est entrée
            usageLimit: usageLimit || null, // null si aucune limite d'utilisation n'est entrée
        };

        // Appeler la fonction passée en props pour créer le coupon
       // console.log(newCoupon);
        //****************************************************************** */
        MyAxios.post(process.env.REACT_APP_API + '/coupons/add/', newCoupon)
            .then((res) => {
               // console.log(res)
                if (res.status === 200) {
                    alert("Sauvegarde complété")
                    setClubNumber('');
                    setTrimestre('');
                    setCouponCode('');
                    setCouponMontant('');
                    setRaison('');
                    setExpirationDate('');
                    setUsageLimit('');

                    // Fermer la boîte de dialogue
                    handleClose();
                }
                else {
                   // console.log(res);
                    alert("Erreur sauvegarde")
                }
            })
            .catch((error) => {

                if (error.response) {
                    // Le serveur a répondu avec un code d'erreur (comme 418 dans votre cas)
                    console.log("Code d'erreur:", error.response.status); // Affiche le code de statut HTTP
                    console.log("Détails de l'erreur:", error.response.data.err); // Affiche les données de la réponse
                    //alert("Erreur sauvegarde: " + error.response.data.custom); // Utilise les informations custom renvoyées
                } else if (error.request) {
                    // La requête a été envoyée mais aucune réponse n'a été reçue
                    console.log("Aucune réponse reçue:", error.request);
                    // alert("Erreur: Pas de réponse du serveur");
                } else {
                    // Erreur lors de la configuration de la requête
                    console.log("Erreur lors de la requête:", error.message);
                    // alert("Erreur: " + error.message);
                }
                let TT = "voir les log.";
                if (error.response.data.err.message)
                    TT = error.response.data.err.message;

                alert("Erreur sauvegarde: " + TT);

            });
        //******************************************************************* */

        // Réinitialiser les champs après la création

    };


    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Créer un nouveau coupon</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            label="Numéro de club"
                            value={clubNumber}
                            onChange={(e) => setClubNumber(e.target.value)}
                            fullWidth
                            required
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Trimestre"
                            select
                            value={trimestre}
                            onChange={(e) => setTrimestre(e.target.value)}
                            fullWidth
                            required
                        >
                            <MenuItem value="1">Trimestre 1</MenuItem>
                            <MenuItem value="2">Trimestre 2</MenuItem>
                            <MenuItem value="3">Trimestre 3</MenuItem>
                            <MenuItem value="4">Trimestre 4</MenuItem>
                        </TextField>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Code du coupon"
                            value={couponCode}
                            onChange={(e) => setCouponCode(e.target.value)}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">Type de réduction</FormLabel>
                            <RadioGroup
                                row
                                aria-label="discount-type"
                                name="discountType"
                                value={discountType}
                                onChange={handleChangeiscountType}
                              
                            >
                                 <FormControlLabel
                                    value="fixed_cart"
                                    control={<Radio />}
                                    label="Montant fixe"
                                />

                                <FormControlLabel
                                    value="percent"
                                    control={<Radio />}
                                    label="Pourcentage"
                                />
                               
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Montant ou pourcentage du coupon (utilisez des virgule et non des points)"
                            value={couponMontant}
                            onChange={handleMontantChange}
                            fullWidth
                            required
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Raison"
                            value={raison}
                            onChange={(e) => setRaison(e.target.value)}
                            fullWidth
                            required
                        />
                    </Grid>

                    <Grid item xs={12}>

                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
                            <DatePicker
                                id="MyYear"
                                label="Date d'expiration (optionnelle)"
                                key="dateExpiration"
                                name="dateExpiration"
                                inputFormat="YYYY-MM-DD"
                                value={expirationDate ? dayjs(expirationDate) : null}
                                // Gérer le cas où la date est supprimée ou non sélectionnée
                                onChange={(newValue) => setExpirationDate(newValue ? dayjs(newValue).format('YYYY-MM-DD') : '')}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => setExpirationDate('')}  // Vider la date quand on clique
                        >
                            Effacer
                        </Button>
                    </Grid>


                    <Grid item xs={12}>
                        <TextField
                            label="Nombre d'utilisations possibles (optionnel)"
                            type="number"
                            value={usageLimit}
                            onChange={(e) => setUsageLimit(e.target.value)}
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    Annuler
                </Button>
                <Button onClick={handleSubmit} color="primary">
                    Créer
                </Button>
            </DialogActions>
        </Dialog>
    );
}
